import { render, staticRenderFns } from "./Reconciliation2.vue?vue&type=template&id=718d20f8&"
import script from "./Reconciliation2.vue?vue&type=script&lang=ts&"
export * from "./Reconciliation2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports